import React from 'react';

import {
    Toast,
    ToastClose,
    ToastDescription,
    ToastProvider,
    ToastTitle,
    ToastViewport,
} from '@/shared/ui/Toast/Toast';
import { useToast } from '@/shared/hooks/useToast';
import { useToastErrors } from '@/shared/hooks/useToastErrors';

export function Toaster() {
    const { toasts } = useToast();

    useToastErrors();

    return (
        <ToastProvider>
            {toasts.map(({ id, title, description, action, onClose, ...props }) => (
                <Toast key={id} {...props}>
                    <div className='grid gap-1'>
                        {title && <ToastTitle>{title}</ToastTitle>}
                        {description && <ToastDescription>{description}</ToastDescription>}
                    </div>
                    {action}
                    <ToastClose onClick={onClose} />
                </Toast>
            ))}
            <ToastViewport />
        </ToastProvider>
    );
}
